import { HK_REPORT_PATH, HK_REPORT_ROOT_PATH } from '../util/reportForHkAccess'

// Type definitions for sidebar contents
export interface SidebarItem {
  key: string;
  linkTo?: string;
  intlMsgId: string;
  iconClassName?: string;
  items?: SidebarItem[];
  children?: SidebarItem[];
}

export interface SidebarContent {
  key: string;
  linkTo?: string;
  intlMsgId: string;
  iconClassName?: string;
  items?: SidebarItem[];
}

export const SIDEBAR_CONTENTS : SidebarContent[] = [
  {
    key: "main/dashboards",
    linkTo: "/main/dashboards",
    intlMsgId: "sidebar.dashboard",
    iconClassName: "icon icon-home",
  },
  {
    key: "hf",
    iconClassName: "icon icon-widgets",
    intlMsgId: "sidebar.hedgeFund",
    items: [
      {
        key: "main/hf/return",
        linkTo: "/main/hf/return",
        intlMsgId: "sidebar.hedgeFund.return",
      },
      {
        key: "main/hf/nav",
        linkTo: "/main/hf/nav",
        intlMsgId: "sidebar.hedgeFund.nav",
      },
      {
        key: "main/hf/port",
        linkTo: "/main/hf/port",
        intlMsgId: "sidebar.hedgeFund.portfolioManagement",
      },
      {
        key: "main/hf/dataDuplication",
        linkTo: "/main/hf/dataDuplication",
        intlMsgId: "sidebar.dataManagement.dataDuplication",
      },
      {
        key: "main/hf/doubleCheck",
        linkTo: "/main/hf/doubleCheck",
        intlMsgId: "sidebar.hedgeFund.doubleCheck",
      },
      {
        key: "main/hf/aum_exposure",
        linkTo: "/main/hf/aum_exposure",
        intlMsgId: "sidebar.hedgeFund.aum.exposure",
      },
    ]
  },
  {
    key: "acct",
    iconClassName: "icon icon-apps",
    intlMsgId: "sidebar.account",
    items: [
      {
        key: "main/acct/nav",
        linkTo: "/main/acct/nav",
        intlMsgId: "sidebar.account.nav",
      },
      {
        key: "main/acct/txn",
        linkTo: "/main/acct/txn",
        intlMsgId: "sidebar.account.investorTransaction",
      },
      {
        key: "main/acct/dataDuplication",
        linkTo: "/main/acct/dataDuplication",
        intlMsgId: "sidebar.dataManagement.dataDuplication",
      },
      {
        key: "main/acct/doubleCheck",
        linkTo: "/main/acct/doubleCheck",
        intlMsgId: "sidebar.hedgeFund.doubleCheck",
      }
    ]
  },
  {
    key: "master",
    iconClassName: "icon icon-card",
    intlMsgId: "sidebar.masterManagement",
    items: [
      {
        key: "main/master/hf",
        linkTo: "/main/master/hf",
        intlMsgId: "sidebar.masterManagement.hedgeFund",
      },
      {
        key: "main/master/acct",
        linkTo: "/main/master/acct",
        intlMsgId: "sidebar.masterManagement.account",
      },
      {
        key: "main/master/investor",
        linkTo: "/main/master/investor",
        intlMsgId: "sidebar.masterManagement.investor",
      },
      {
        key: "main/master/organization",
        linkTo: "/main/master/organization",
        intlMsgId: "sidebar.masterManagement.organization",
      }
    ]
  },
  {
    key: "monthlyReport",
    iconClassName: "icon icon-calendar",
    intlMsgId: "sidebar.monthlyReport",
    items: [
      {
        key: "main/monthly-report/acct",
        linkTo: "/main/monthly-report/acct",
        intlMsgId: "sidebar.monthlyReport.account",
      },
      {
        key: "main/monthly-report/hf",
        linkTo: "/main/monthly-report/hf",
        intlMsgId: "sidebar.monthlyReport.hedgeFund",
      },
    ]
  },
  {
    key: "Analyze",
    iconClassName: "icon icon-schedule",
    intlMsgId: "sidebar.analyze",
    items: [
      {
        key: "main/analyze/hfs",
        linkTo: "/main/analyze/hfs",
        intlMsgId: "head.hedgeFunds",
      },
      {
        key: "main/analyze/accts",
        linkTo: "/main/analyze/accts",
        intlMsgId: "head.accounts",
      },
      {
        key: "main/analyze/investors",
        linkTo: "/main/analyze/investors",
        intlMsgId: "head.investors",
      },
      {
        key: "main/analyze/marketData",
        linkTo: "/main/analyze/marketData",
        intlMsgId: "sidebar.dataManagement.marketData",
      },
      {
        key: "main/analyze/dividend_file",
        linkTo: "/main/analyze/dividend_file",
        intlMsgId: "sidebar.monthlyReport.dividendFile",
      },
      {
        key: "OSBReport",
        intlMsgId: "sidebar.tool.osb_report",
        children: [
          {
            key: "main/analyze/osb_report",
            linkTo: "/main/analyze/osb_report",
            intlMsgId: "sidebar.tool.osb_report.investment_performance",
          },
          {
            key: "main/analyze/osb_monthly_performance",
            linkTo: "/main/analyze/osb_monthly_performance",
            intlMsgId: "sidebar.tool.osb_report.monthly_investment_performance",
          },
        ]
      },
    ]
  },
  {
    key: "analyticalTool",
    iconClassName: "icon icon-stats",
    intlMsgId: "sidebar.analytical.tool",
    items: [
      {
        key: "main/analytical/allocation_map",
        linkTo: "/main/analytical/allocation_map",
        intlMsgId: "sidebar.tool.allocation_map",
      },
      {
        key: "main/analytical/fofs_summary_report",
        linkTo: "/main/analytical/fofs_summary_report",
        intlMsgId: "sidebar.tool.fofs_summary",
      },
      {
        key: "main/analytical/fof_weekly_trend",
        linkTo: "/main/analytical/fof_weekly_trend",
        intlMsgId: "sidebar.tool.fof_weekly_trend",
      },
      {
        key: "main/analytical/fof_ytd_graph",
        linkTo: "/main/analytical/fof_ytd_graph",
        intlMsgId: "sidebar.tool.fof_ytd_graph",
      },
      {
        key: "main/analytical/allocation_ytdReturn",
        linkTo: "/main/analytical/allocation_ytdReturn",
        intlMsgId: "sidebar.tool.allocation.YTD_return",
      },
      {
        key: "main/analytical/fund_attribution_report",
        linkTo: "/main/analytical/fund_attribution_report",
        intlMsgId: "sidebar.tool.allocation.attribution_report",
      },
      {
        key: "main/analytical/fund_check_list",
        linkTo: "/main/analytical/fund_check_list",
        intlMsgId: "sidebar.tool.fund_check_list",
      },
      {
        key: "main/analytical/fund_data_list",
        linkTo: "/main/analytical/fund_data_list",
        intlMsgId: "sidebar.tool.fund_data_list",
      },
      {
        key: "main/analytical/fund_performance_report",
        linkTo: "/main/analytical/fund_performance_report",
        intlMsgId: "sidebar.tool.fund_performance_rp",
      },
      {
        key: "main/analytical/fund_survey",
        linkTo: "/main/analytical/fund_survey",
        intlMsgId: "sidebar.tool.fund_survey",
      },
      {
        key: "main/analytical/fund_survey_share",
        linkTo: "/main/analytical/fund_survey_share",
        intlMsgId: "sidebar.tool.fund_survey_share",
      },
      {
        key: "main/analytical/hfr_strategy_report",
        linkTo: "/main/analytical/hfr_strategy_report",
        intlMsgId: "sidebar.tool.HFR.strategy",
      },
      {
        key: "Historical",
        intlMsgId: "sidebar.tool.historical_download",
        children: [
          {
            key: "main/analytical/index_return",
            linkTo: "/main/analytical/index_return",
            intlMsgId: "sidebar.tool.index_return",
          },
          {
            key: "main/analytical/portfolio_statistics",
            linkTo: "/main/analytical/portfolio_statistics",
            intlMsgId: "sidebar.tool.portfolio_statistics",
          },
        ]
      },
      {
        key: "main/analytical/monitoring_list",
        linkTo: "/main/analytical/monitoring_list",
        intlMsgId: "sidebar.tool.monitoring_list",
      },
      {
        key: "main/analytical/monthly_allocation_changes",
        linkTo: "/main/analytical/monthly_allocation_changes",
        intlMsgId: "sidebar.tool.monthly_allo_changes",
      },
      {
        key: "main/analytical/monthly_fund_performance",
        linkTo: "/main/analytical/monthly_fund_performance",
        intlMsgId: "sidebar.tool.monthly_per_loader",
      },
      {
        key: "main/analytical/mtd_performance_report",
        linkTo: "/main/analytical/mtd_performance_report",
        intlMsgId: "sidebar.tool.mtd_report",
      },
      {
        key: "main/analytical/redemption_schedule",
        linkTo: "/main/analytical/redemption_schedule",
        intlMsgId: "sidebar.tool.fund_prof_schedule",
      },
      {
        key: "main/analytical/return_by_stg",
        linkTo: "/main/analytical/return_by_stg",
        intlMsgId: "sidebar.tool.return_bt_stg",
      },
      {
        key: "main/analytical/trailing_return_screening",
        linkTo: "/main/analytical/trailing_return_screening",
        intlMsgId: "sidebar.tool.trailing_return_screening",
      },
      {
        key: "main/analytical/strategy_allocation_contributions",
        linkTo: "/main/analytical/strategy_allocation_contributions",
        intlMsgId: "sidebar.tool.strategy_allo_contributions",
      },
      {
        key: "main/analytical/top_contributor",
        linkTo: "/main/analytical/top_contributor",
        intlMsgId: "sidebar.tool.top_contributor",
      },
      {
        key: "main/analytical/war_report",
        linkTo: "/main/analytical/war_report",
        intlMsgId: "sidebar.tool.war_report",
      },
      {
        key: "main/analytical/ytd_contribution",
        linkTo: "/main/analytical/ytd_contribution",
        intlMsgId: "sidebar.tool.ytd_contribution",
      },
    ]
  },
  {
    key: HK_REPORT_ROOT_PATH.slice(1),
    intlMsgId: 'sidebar.reportForHk',
    iconClassName: 'icon icon-calendar',
    items: [
      {
        key: HK_REPORT_PATH.slice(1),
        linkTo: HK_REPORT_PATH,
        intlMsgId: 'hkReport.title',
      },
    ],
  },
  {
    key: "administration",
    iconClassName: "icon icon-auth-screen",
    intlMsgId: "sidebar.administrationMenu",
    items: [
      {
        key: "main/administration/users",
        linkTo: "/main/administration/users",
        intlMsgId: "sidebar.administrationMenu.users",
      },
      {
        key: "main/administration/marketData",
        linkTo: "/main/administration/marketData",
        intlMsgId: "sidebar.dataManagement.marketData",
      },
      {
        key: "main/administration/historicalReturnImport",
        linkTo: "/main/administration/historicalReturnImport",
        intlMsgId: "sidebar.administrationMenu.historicalReturnImport",
      },
    ]
  }
]
